import Loader from './Loader';

export { Loader };
export default Loader;
